var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeformShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#freeform_shape_svg__clip0_2668_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.92 17.589H4.706L2.618 1.743 17.92 4.405v13.191-.007zM6 16.119h10.457V5.638L4.338 3.538 6 16.126v-.008z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.478 3.596a1.118 1.118 0 100-2.236 1.118 1.118 0 000 2.236z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.478 3.963A1.478 1.478 0 012 2.485C2 1.67 2.662 1 3.478 1a1.478 1.478 0 010 2.956v.007zm0-2.235a.753.753 0 00-.75.75c0 .412.338.75.75.75s.75-.338.75-.75a.753.753 0 00-.75-.75z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.463 17.971a1.118 1.118 0 100-2.235 1.118 1.118 0 000 2.235z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.463 18.34a1.478 1.478 0 110-2.957 1.478 1.478 0 010 2.956zm0-2.229a.753.753 0 00-.75.75c0 .412.339.75.75.75.412 0 .75-.338.75-.75a.753.753 0 00-.75-.75z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.185 5.883a1.081 1.081 0 100-2.162 1.081 1.081 0 000 2.162z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.185 6.228c-.081 0-.17 0-.25-.022a1.429 1.429 0 01-1.155-1.662c.14-.78.883-1.294 1.662-1.154.375.066.706.28.92.588.212.309.3.691.235 1.066a1.431 1.431 0 01-1.405 1.177l-.007.007zm0-2.154a.73.73 0 00-.714.595.72.72 0 00.589.839.72.72 0 00.838-.589.72.72 0 00-.588-.838c-.044-.007-.089-.015-.125-.015v.008z",
    fill: "#98BDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.185 17.971a1.118 1.118 0 100-2.235 1.118 1.118 0 000 2.235z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.185 18.34a1.478 1.478 0 110-2.957 1.478 1.478 0 010 2.956zm0-2.229a.753.753 0 00-.75.75c0 .412.338.75.75.75.411 0 .75-.338.75-.75a.753.753 0 00-.75-.75z",
    fill: "#98BDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freeform_shape_svg__clip0_2668_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 1)",
    d: "M0 0h16.67v17.339H0z"
  })))));
}
export default SvgFreeformShape;